<template>
    <el-drawer
        title="更新座位图"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        append-to-body
    >
        <div class="drawer-content">
            <el-alert type="warning" :closable="false" title="注意事项">
                <ul>
                    <li>1、尽量在区域信息的座位信息有更新、修改,或删除的情况下，才进行更新</li>
                    <li>2、更新之后不会直接影响到演出</li>
                    <li>3、如果要在演出上执行更新操作, 请到演出上执行更新座位图版本的操作</li>
                </ul>
            </el-alert>
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                class="MT20"
            >
                <el-form-item prop="remark" label="更新备注：">
                    <el-input v-model="formData.remark" maxlength="200" type="textarea" :rows="4" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    id:"",
    remark: ""
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                remark: [{ required: true, message: "请输入更新备注" }],
            },
        }
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.$refs['formData'].clearValidate();
            this.drawerShow = false;
        },
        show(id) {
            this.formData.id = id;
            this.drawerShow = true;
        },
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/site/updateSeat',
                        params: {
                            ...this.formData
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        }); 
                } else {
                    return false;
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>